import script from "./TapItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TapItem.vue?vue&type=script&setup=true&lang=js"

import "./TapItem.vue?vue&type=style&index=0&id=b6095482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6095482"]])

export default __exports__